<template>
  <el-card>
    <div class="text-center text-secondary">
      <slot name="icon">
        <!-- <h1 class="bg-success"><i class="mdi mdi-account-hard-hat"></i></h1> -->
        <img src="/static/images/worker.png" alt="Worker" />
      </slot>
      <slot>
        <h1>Este seccion esta en construccion.</h1>
      </slot>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "ComponentInWorker"
};
</script>

<style></style>
